import { createStore } from 'redux';
import rootReducer from '../reducers';

export default function configureStore (initialState) {
	const store = createStore(
		rootReducer,
		initialState
	);

	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', () => {
			/* eslint-disable global-require */
			const nextReducer = require('../reducers');
			/* eslint-enable global-require */
			store.replaceReducer(nextReducer);
		});
	}

	return store;
}



// WEBPACK FOOTER //
// ./public/src/store/configure.js